// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"8ffe4d48","527":"55304c38"}[chunkId] + ".chunk.js";
};